import * as Actions from './common.actions';
import { ICommonState } from './common.state';
import { Action, createReducer, on } from '@ngrx/store';

export const commonState: ICommonState = {
  isFetching: false,
  isSending: false,  
  latestJourney: null
};

const reducerList = createReducer(commonState,


  on(Actions.IsFetchingAction, (state, { payload }) => {
    return {
      ...state,
      isFetching: payload,
    };
  }),
  on(Actions.IsSendingAction, (state, { payload }) => {
    return {
      ...state,
      isSending: payload,
    };
  }),

  on(Actions.GetJourneyStepsResponseAction, (state, { journey }) => {
    return {
      ...state,
      latestJourney: journey,
    };
  }),
);

export function commonReducer(state: any | undefined, action: Action) {
  return reducerList(state, action);
}
